import { getSetting, saveSetting } from "@/api/user";

const state = {
  settingdata: {
    male: false, //男声
    female: true, //女声
    auto: true, //答错出现技巧
    next: true, //答对下一题
    tip: true, // 提示语音
    fonts: 30, //字体
    keySkill: false, // 关键字
    is_rand: 0,
  },
  dumiaoList: [], // 三力测试读秒题
  needUpload: false,
};

const mutations = {
  SET_SETTING_DATA(state, settingData) {
    state.settingdata = Object.assign({}, state.settingdata, settingData);
  },
  SET_DUMIAO_LIST(state, dumiaoList) {
    state.dumiaoList = dumiaoList; // 更新读秒题列表
  },
};

const actions = {
  setSettingData({ commit }, settingData) {
    commit("SET_SETTING_DATA", settingData);
  },
  setDumiaoList({ commit }, dumiaoList) {
    commit("SET_DUMIAO_LIST", dumiaoList);
  },
  initSetting({ commit, state }) {
    getSetting().then((response) => {
      const settingData = response.data;
      const obj = {
        male: settingData.voice_male == 1 ? true : false, //男声
        female: settingData.voice_female == 1 ? true : false, //女声
        auto: settingData.auto_explain == 1 ? true : false, //答错出现技巧
        next: settingData.auto_jump_next == 1 ? true : false, //答对下一题
        tip: settingData.voice_tip == 1 ? true : false, // 提示语音
        fonts: settingData.font_size, //字体
        keySkill: false,
        is_rand: settingData.is_rand,
      };
      state.settingdata = obj;
    });
  },
  uploadSettingData({ state }) {
    const { settingdata } = state;
    const data = {
      voice_male: settingdata.male ? 1 : 0, //男声
      voice_female: settingdata.female ? 1 : 0, //女声
      auto_explain: settingdata.auto ? 1 : 0, //答错出现技巧
      auto_jump_next: settingdata.next ? 1 : 0, //答对下一题
      voice_tip: settingdata.tip ? 1 : 0, // 提示
      font_size: settingdata.fonts,
      is_rand: settingdata.is_rand,
    };
    saveSetting(data).then(() => {});
  },
};

const getters = {
  settingdata: (state) => state.settingdata,
  dumiaoList: (state) => state.dumiaoList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
